import dynamic from 'next/dynamic'

export const DynamicItemLoader = dynamic(() =>
	import('./ItemLoader').then(({ ItemLoader }) => ItemLoader)
)
